import { MenuItem, Select } from "@mui/material";

const getShopItems = (shops, customerId) => {
  
  const shopsByCustomerId = shops.filter((shop) => shop.customerId === customerId);

  if (!customerId || shopsByCustomerId.length === 0) {
    return [{key: "shop_not_selected", value: "shop_not_selected", label: "[未選択]"}];
  }

  return shopsByCustomerId.map((shop) => ({
    key: `shop_${shop.shopId}`,
    value: shop.shopId.toString(),
    label: shop.shopName === "　" ? "本店" : shop.shopName
  }));
}


function ShopSelect({shops, customerId, selectedShopId, onChangeShop, error, ...props}) {

  const MenuItems = getShopItems(shops, customerId).map((item) => (
    <MenuItem key={item.key} value={item.value}>
      {item.label}
    </MenuItem>
  ));

  const handleChangeShopSelect = (e) => {
    const selectValue = e.target.value;
    onChangeShop(selectValue === "customer_not_selected" ? null : parseInt(selectValue));
  }

  return (
    <Select
      labelId={props.lavelId || ''}
      value={selectedShopId?.toString() || 'shop_not_selected'}
      onChange={handleChangeShopSelect}
      error={error}
      {...props}
    >
      {MenuItems}
    </Select>
  )
}

export default ShopSelect;

